<template>
	<div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="formData.program_code" :faculty_code="34" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('name')">
                            <b-form-input
                                v-model="formData.name"
                                :state="errors[0] ? false:null">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="exam_code" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('exam_code')">
                            <b-form-input
                                v-model="formData.exam_code"
                                :state="errors[0] ? false:null">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="weight" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('weight')">
                            <b-form-input v-model="formData.weight"
                                          type="number"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('sort')">
                        <ValidationProvider name="sort" rules="" v-slot="{ errors }">
                            <b-form-input v-model="formData.sort"
                                          type="number"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="updateForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
	</div>
</template>

<script>
// Components
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";

// Services
import GraduateApplicationEvaluationExamService from "@/services/GraduateApplicationEvaluationExamService";
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,

        ProgramSelectbox
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                program_code:null,
                name:null,
                exam_code:null,
                weight:null,
                sort:null,
            },
            formLoading: false,
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            GraduateApplicationEvaluationExamService.get(id)
                         .then(response => {
                             let data = response.data.data;
                             this.formData = {
                                 program_code:data.program_code,
                                 name:data.name,
                                 exam_code:data.exam_code,
                                 weight:data.weight,
                                 sort:data.sort,
                             }
                         })
                         .catch(e => {
                             this.showErrors(e)
                         })
        },

        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.formLoading = true;
                GraduateApplicationEvaluationExamService.update(this.formId, this.formData)
                             .then(response => {
                                 this.$emit('updateFormSuccess', true);
                                 this.$toast.success(this.$t('api.' + response.data.message));
                             })
                             .catch(e => {
                                 this.showErrors(e, this.$refs.formModalValidate);
                             })
                             .finally(() => {
                                 this.formLoading = false
                             })
            }
        }
    }
}
</script>
